export default __webpack_public_path__ + "static/media/Guru-Parampara-10.9605541d.png";